



































































import { Component, Vue } from 'vue-property-decorator';
import QRCode from 'qrcode';

import { API_BASE_URL, MOBILE_APP_URL } from '@/scripts/global/runtime-config';

// `toastr` metronic vendors bundle'indan gelen GLOBAL ornek; npm modulunu
// import etmek ayri bir ornek yaratir ve main.ts'teki ayarlar uygulanmaz.

/**
 * Mobil cihaz esleme ekrani: saha uygulamasinin (cfm-app) hangi CFM sunucusuna
 * baglanacagini karekodla anlatir.
 *
 * Karekod YALNIZ sunucu adresini tasir; oturum, token ya da kisisel veri
 * icermez. Tek istemci birden fazla musteri backend'ine baglanabildigi icin
 * mobil tarafin ilk ihtiyaci "hangi sunucu" sorusunun cevabidir; kimlik
 * dogrulama sonraki adimda, kullanicinin kendi parolasiyla yapilir.
 *
 * Baglanti bicimi mobil taraftaki `ConnectLink` ile birebir ayni:
 *   <uygulama-adresi>/#/connect?api=<url-kodlu API koku>&name=<kurum>
 * Telefonun kamera uygulamasiyla okutuldugunda dogrudan uygulamayi acar;
 * uygulama icindeki tarayici da ayni metni cozer.
 *
 * Route bilincli olarak authItem TASIMIYOR (Profile ile ayni gerekce): ekran
 * yalnizca zaten oturum acmis kullaniciya kendi sunucusunun adresini
 * gosteriyor, yeni bir yetki alani acmiyor.
 */
@Component
export default class MobileDevicePairing extends Vue {
  qrError = '';

  /** API kok adresi; sondaki egik cizgi normalize edilir. */
  get apiBaseUrl(): string {
    const raw = (API_BASE_URL || '').trim();
    if (!raw) return '';
    return raw.endsWith('/') ? raw : `${raw}/`;
  }

  /** Saha uygulamasinin yayinlandigi adres. */
  get mobileAppUrl(): string {
    const raw = (MOBILE_APP_URL || '').trim();
    return raw.replace(/\/+$/, '');
  }

  /** Kurum adi karekoda yazilir; mobil onay ekraninda gosterilir. */
  get companyName(): string {
    try {
      const raw = localStorage.getItem('company');
      if (!raw) return '';
      const company = JSON.parse(raw);
      return (company && (company.Name || company.CompanyName)) || '';
    } catch (e) {
      return '';
    }
  }

  /**
   * Mobil uygulama http adresleri reddeder (tarayici da karma icerigi engeller).
   * Adres https degilse esleme calismaz; kullaniciya burada soylenir.
   */
  get isSecureAddress(): boolean {
    return /^https:\/\//i.test(this.apiBaseUrl);
  }

  get pairingLink(): string {
    if (!this.apiBaseUrl || !this.mobileAppUrl) return '';
    const params = [`api=${encodeURIComponent(this.apiBaseUrl)}`];
    if (this.companyName) {
      params.push(`name=${encodeURIComponent(this.companyName)}`);
    }
    return `${this.mobileAppUrl}/#/connect?${params.join('&')}`;
  }

  mounted() {
    this.renderQr();
  }

  renderQr() {
    const canvas = this.$refs.qrCanvas as HTMLCanvasElement;
    if (!canvas) return;
    if (!this.pairingLink) {
      this.qrError = this.translate('mobile_pairing_missing_config');
      return;
    }
    QRCode.toCanvas(
      canvas,
      this.pairingLink,
      {
        width: 260,
        margin: 1,
        errorCorrectionLevel: 'M',
        color: { dark: '#0F1A20', light: '#FFFFFF' },
      },
      (error: Error | null | undefined) => {
        this.qrError = error ? this.translate('mobile_pairing_qr_failed') : '';
      },
    );
  }

  copy(value: string) {
    if (!value) return;
    const done = () => toastr.success(this.translate('copied'));
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(value).then(done, () => this.fallbackCopy(value, done));
      return;
    }
    this.fallbackCopy(value, done);
  }

  /** Panoya erisim yoksa (http sayfa, eski tarayici) secim uzerinden kopyalar. */
  private fallbackCopy(value: string, done: () => void) {
    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', 'readonly');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      done();
    } catch (e) {
      toastr.error(this.translate('mobile_pairing_copy_failed'));
    }
    document.body.removeChild(input);
  }
}
